import React from "react";
import { useTranslation } from "react-i18next";
import { AURORA_THEME } from "./theme";

// Slim dark footer rendered on /c/aurora in place of the global Footer (which is
// light-themed and would break the dark-mode flow). Intentionally minimal — just
// brand identity and copyright.

const AuroraDarkFooter = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer
      className="tw-w-full tw-py-10"
      style={{ backgroundColor: AURORA_THEME.bg.primary }}
    >
      <div className="tw-mx-auto tw-flex tw-max-w-6xl tw-flex-col tw-items-center tw-gap-4 tw-px-6 tw-text-center">
        <img
          src="https://d1puf2nnbcyl9q.cloudfront.net/1784267938955_aurora-promise-logo.png.png"
          alt={t("campaign.aurora.hero.title")}
          className="tw-h-16 tw-w-auto"
          // Brighten the dark-blue wordmark so it stays legible on the deep-navy footer
          // (the previous asset was a dedicated white variant; this is the single final logo).
          style={{ filter: "brightness(1.75)" }}
        />
        <p
          className="tw-text-xs"
          style={{ color: AURORA_THEME.text.muted }}
        >
          © {year} Sotravel · {t("campaign.aurora.footer.tagline")}
        </p>
      </div>
    </footer>
  );
};

export default AuroraDarkFooter;
